<template>
    <div class="record-container">
        <el-tabs class="elTabs" v-model="tab_active" type="border-card" stretch @tab-click="tabClick">
            <el-tab-pane label="告警流水" name="1">
                <el-button
                    type="primary"
                    plain
                    :icon="DArrowRight"
                    size="small"
                    @click="$router.push({ path: '/valve/valve-history-event' })"
                    style="width: calc(100% - 30px); margin: 15px"
                >
                    更多
                </el-button>
                <el-scrollbar class="list">
                    <el-timeline v-if="alarm_list?.length">
                        <el-timeline-item
                            v-for="item in alarm_list"
                            :key="item.id"
                            :color="item.color"
                            :size="item.size"
                            :hollow="item.hollow"
                        >
                            <div class="list-item">
                                <div class="item-title" v-if="item.alarm_type === 1">掉电故障</div>
                                <div class="item-title" v-else-if="item.alarm_type === 2">位移故障</div>
                                <div class="item-title" v-else-if="item.alarm_type === 3">离线故障</div>
                                <div class="item-title" v-else-if="item.alarm_type === 4">市电掉电报警</div>
                                <div class="item-title" v-else-if="item.alarm_type === 5">电池低电压报警</div>
                                <div class="item-title" v-else-if="item.alarm_type === 6">防拆报警</div>
                                <div class="item-title" v-else-if="item.alarm_type === 7">阀门堵转</div>
                                <div class="item-title" v-else-if="item.alarm_type === 8">温度传感器报警</div>
                                <div class="item-info">{{ item.device_name }}</div>
                                <div class="item-info" :title="room_list[item.room]">
                                    {{ room_list[item.room] }}
                                </div>
                                <div class="time">{{ item.happen_time }}</div>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                    <div v-else class="noData">
                        <div>暂无告警信息</div>
                    </div>
                </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane label="远程控制" name="2">
                <el-button
                    type="primary"
                    plain
                    :icon="DArrowRight"
                    size="small"
                    @click="$router.push({ path: '/valve/valve-control-record' })"
                    style="width: calc(100% - 30px); margin: 15px"
                >
                    更多
                </el-button>
                <el-scrollbar class="list">
                    <el-timeline v-if="control_list?.length">
                        <el-timeline-item
                            v-for="item in control_list"
                            :key="item.id"
                            :color="item.color"
                            :size="item.size"
                            :hollow="item.hollow"
                        >
                            <div class="list-item">
                                <div class="item-title" v-if="item.alarm_type === 1">开阀</div>
                                <div class="item-title" v-else-if="item.alarm_type === 2">关阀</div>
                                <div class="item-title" v-else-if="item.alarm_type === 3">控制开度</div>
                                <div class="item-info">成功</div>
                                <div class="item-info" :title="room_list[item.room]">
                                    {{ room_list[item.room] }}
                                </div>
                                <div class="time">{{ item.happen_time }}</div>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                    <div v-else class="noData">
                        <div>暂无告警信息</div>
                    </div>
                </el-scrollbar>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { DArrowRight } from '@element-plus/icons'
import { useRoute } from 'vue-router'
import { getOptionTree } from '@/api/room.js'
import { getAlarmLogList } from '@/api/heating/monitoring.js'
// 判断路由
const route = useRoute()
const path = ref('')
path.value = route.path

// tab
const tab_active = ref('1')
function tabClick(tab) {
    if (tab_active.value === '1') {
        getAlarmList()
    } else {
        getControlList()
    }
    tab_active.value = tab.props.name
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        console.log(data)
        const room_locations = {}

        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }

        getRoom(data, '')
        room_list.value = room_locations
    })
}

// 获取告警流水
const alarm_list = ref([])
const getAlarmList = async () => {
    const res = await getAlarmLogList({
        type: 3
    })
    alarm_list.value = res.lists
}

// 获取远程控制流水
const control_list = ref([])
const getControlList = async () => {
    const res = await getAlarmLogList({
        type: 3
    })
    control_list.value = res.lists
}

onMounted(() => {
    getRoomTree()
    getAlarmList()
})
</script>

<style lang="scss" scoped>
.noData {
    width: 100%;
    height: calc(100% - 70px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.record-container {
    margin-right: 15px;
    height: 100%;
    .dot {
        box-shadow: none !important;
        align-items: center;
    }
    .ellipsis {
        cursor: pointer;
    }
    .ellipsis:focus-visible {
        outline: none;
    }
    .title {
        display: flex;
        justify-content: space-between;
        margin: 15px;
        span {
            font-size: 16px;
            font-weight: 700;
            color: #606266;
        }
    }
    .elTabs {
        width: 100%;
        height: 100%;
    }
    .elTabs:deep(.el-tabs__content) {
        height: calc(100% - 39px);
        padding: 0;
    }
    .elTabs:deep(.el-tab-pane) {
        height: 100%;
    }
    .list {
        padding: 0 15px;
    }
    .list-item {
        margin-left: 10px;
        line-height: 22px;
        .item-title {
            font-size: 16px;
        }
        .item-info {
            width: 100%;
            color: #717171;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
        }
        .time {
            font-size: 12px;
            color: #c2c2c2;
        }
    }
}
</style>
